import React from 'react';
import { connect } from 'react-redux';
// import FontIcon from 'react-toolbox/lib/font_icon';
import Title from '~/components/Title';
import { get } from '~/actions/actions';
import style from './style.scss';

class Container extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: !this.props.item && this.props.id
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      get(this.props.dispatch, this.context.apiClient, this.props.id)
        .then(() => this.setState({ loading: false }))
        .catch(() => this.setState({ loading: false }));
    }
  }

  renderItem() {
    const action = this.props.item.toJS();
    return (
      <div onClick={() => this.context.dialogPush('action', { id: action.id })}>
        <div>
          <Title>#{action.sku} - {action.name}</Title>
        </div>
        {action.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { id, item, className, dispatch, ...props } = this.props;
    return (
      <div className={[style.container, className].join(' ')} {...props}>
        <div className={style.content}>
          {this.state.loading && 'Loading'}
          {!this.state.loading && !item && '404'}
          {!this.state.loading && item && this.renderItem()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['actions', 'items', props.id]),
});

export default connect(mapStateToProps)(Container);



// WEBPACK FOOTER //
// ./app/components/Action/index.js